import { useLocation } from 'react-router-dom';

import { IconArrowLeft } from '@components/icons/arrow-left';
import { Nav } from '@components/nav';
import { HireNav } from '@components/nav/nav';
import { Text } from '@components/text';

import { useProfileNavigationItems } from 'hooks/use-profile-navigation-items';
import { useStore } from 'models/Provider';

type LocationState = {
  from: string;
};

export const ProfileNavigation = () => {
  const { t } = useStore();
  const items = useProfileNavigationItems();
  const location = useLocation();
  const { from } = (location.state as LocationState) || { from: '/' };

  return (
    <HireNav
      variant="static"
      fixedHeader={
        <Nav.Header
          logo={
            <Nav.Link
              href={from}
              label={<Text font="bold14" caps text={t('navigation.back')} color="white100" />}
              iconLeft={<IconArrowLeft color="white100" />}
            />
          }
        />
      }
    >
      <Nav.GroupHeader text={t('navigation.profile.headers.profile')} />
      <Nav.Group>
        {items.map((item) => (
          <Nav.Link key={item.path} href={item.path} label={item.label} iconLeft={item.icon} />
        ))}
      </Nav.Group>
    </HireNav>
  );
};
